import { all, call, put, takeLatest } from "redux-saga/effects";
import {
    fetchTreeHierarchyApi,
    getAdminBackoutsListApi,
    getAdminBDMMetricsGroup,
    getAdminBDMMetricsOverview,
    getAdminMetrics,
    getAdminRAMetricsGroup,
    getAdminRAMetricsOverview,
    getAdminRecruiterMetricsGroup,
    getAdminRecruiterMetricsOverview,
    getAllUsers,
    getBDMJobsMetrics,
    getBDMMetrics,
    getBDMTableDataApi,
    getPlacementsListApi,
    getRAJobPostingMetrics,
    getRAMetrics,
    getRAMetricsGroup,
    getRAMetricsOverview,
    getRecruiterMetrics,
    getRecruiterMetricsGroup,
    getTotalAccountsFromJobsApi
} from "./atsDashboardApi.js";
import {
    getAdminBDMMetricsGroupStart,
    getAdminBDMMetricsGroupSuccess,
    getAdminBDMMetricsOverviewStart,
    getAdminBDMMetricsOverviewSuccess,
    getAdminCompareMetricsStart,
    getAdminCompareMetricsSuccess,
    getAdminMetricsStart,
    getAdminMetricsSuccess,
    getAdminRAMetricsGroupStart,
    getAdminRAMetricsGroupSuccess,
    getAdminRAMetricsOverviewStart,
    getAdminRAMetricsOverviewSuccess,
    getAdminRecruiterMetricsGroupStart,
    getAdminRecruiterMetricsGroupSuccess,
    getAdminRecruiterMetricsOverviewStart,
    getAdminRecruiterMetricsOverviewSuccess,
    getAdminUsersStart,
    getBDMCompareMetricsStart,
    getBDMMetricsGroupStart,
    getBDMMetricsOverviewStart,
    getBDMMetricsStart,
    getBDMRoleBasedMetricsStart,
    getCompareMetricsSuccess,
    getCompareTeamMetricsSuccess,
    getMetricsFailure,
    getMetricsGroupSuccess,
    getMetricsOverviewSuccess,
    getMetricsSuccess,
    getRACompareMetricsStart,
    getRAMetricsGroupStart,
    getRAMetricsOverviewStart,
    getRAMetricsStart,
    getRARoleBasedMetricsStart,
    getRecruiterCompareMetricsStart,
    getRecruiterMetricsGroupStart,
    getRecruiterMetricsOverviewStart,
    getRecruiterMetricsStart,
    getRecruiterRoleBasedMetricsStart,
    getRoleBasedMetricsSuccess,
    getTeamMetricsGroupSuccess,
    getTeamMetricsOverviewSuccess,
    getTeamMetricsSuccess,
    getTeamRoleBasedMetricsSuccess,
    getTreeHierarchyDataFailure,
    getTreeHierarchyDataStart,
    getTreeHierarchyDataSuccess,
    getTreeHierarchyNodeDataFailure,
    getTreeHierarchyNodeDataStart,
    getTreeHierarchyNodeDataSuccess,
    revertStateLoading,
    setAdminBDMUsers,
    setAdminRAUsers,
    setAdminRecruiterUsers,
    getTreeHierarchyNodeTab2DataStart,
    getTreeHierarchyNodeTab2DataSuccess,
    getTreeHierarchyNodeTab2DataFailure,
    getTreeHierarchyNodeTab3DataStart,
    getTreeHierarchyNodeTab3DataSuccess,
    getTreeHierarchyNodeTab3DataFailure,
    getTreeHierarchyNodeTab3TotalCountStart,
    getTreeHierarchyNodeTab3TotalCountSuccess,
    getTreeHierarchyNodeTab3TotalCountFailure,
    getTreeHierarchyNodeBDMStart,
    getTreeHierarchyNodeBDMSuccess,
    getTreeHierarchyNodeBDMFailure,
    getTreeHierarchyExtraCountsDataStart,
    getTreeHierarchyExtraCountsDataSuccess,
    getTreeHierarchyExtraCountsDataFailure,
    getBDMTableDataStart,
    getBDMTableDataSuccess,
    getBDMTableDataFailure,
    getAdminTotalAccountsListStart,
    getAdminTotalAccountsListSuccess,
    getAdminTotalAccountsListFailure,
    getBackoutListStart,
    getBackoutListSuccess,
    getBackoutListFailure,
    getPlacementsListStart,
    getPlacementsListSuccess,
    getPlacementsListFailure,

    //recruit tree hirer
    getRecruitTreeHierarchyDataStart,
    getRecruitTreeHierarchyDataSuccess,
    getRecruitTreeHierarchyDataFailure,

    getRecruitTreeHierarchyNodeDataStart,
    getRecruitTreeHierarchyNodeDataSuccess,
    getRecruitTreeHierarchyNodeDataFailure,

    getRecruitTreeHierarchyNodeTab2DataStart,
    getRecruitTreeHierarchyNodeTab2DataSuccess,
    getRecruitTreeHierarchyNodeTab2DataFailure,

    getRecruitTreeHierarchyNodeTab3DataStart,
    getRecruitTreeHierarchyNodeTab3DataSuccess,
    getRecruitTreeHierarchyNodeTab3DataFailure,

    getRecruitTreeHierarchyNodeTab3TotalCountStart,
    getRecruitTreeHierarchyNodeTab3TotalCountSuccess,
    getRecruitTreeHierarchyNodeTab3TotalCountFailure,

    getRecruitTreeHierarchyNodeBDMStart,
    getRecruitTreeHierarchyNodeBDMSuccess,
    getRecruitTreeHierarchyNodeBDMFailure,

    gettreeHierarchyMetricWiseDataFailure,
    gettreeHierarchyMetricWiseDataSuccess,
    gettreeHierarchyMetricWiseDataStart,

    getrecruitTreeHierarchyMetricWiseDataFailure,
    getrecruitTreeHierarchyMetricWiseDataSuccess,
    getrecruitTreeHierarchyMetricWiseDataStart,

    getTreeHierarchyRecruitExtraCountsDataStart,
    getTreeHierarchyRecruitExtraCountsDataSuccess,
    getTreeHierarchyRecruitExtraCountsDataFailure
} from "./atsDashboardSlice.js";

function* getRAMetricsData(params) {
    const actionValue = params.payload
    const isTeam = params.payload?.type;
    const isCompare = params.payload?.isCompare;

    try {
        const response = yield call(getRAMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                if (isCompare) {
                    yield put(getCompareTeamMetricsSuccess(response?.data?.data || {}))
                } else {
                    yield put(getTeamMetricsSuccess(response?.data?.data || {}))
                }
            } else {
                if (isCompare) {
                    yield put(getCompareMetricsSuccess(response?.data?.data || {}))
                } else {
                    yield put(getMetricsSuccess(response?.data?.data || {}));
                }
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRAMetricsOverviewData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getRAMetricsOverview, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamMetricsOverviewSuccess(response?.data?.data || {}))
            } else {
                yield put(getMetricsOverviewSuccess(response?.data?.data || {}));
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRARoleBasedMetricsData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getRAJobPostingMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamRoleBasedMetricsSuccess(response?.data?.data || {}))
            } else {
                yield put(getRoleBasedMetricsSuccess(response?.data?.data || {}));
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRAMetricsGroupData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getRAMetricsGroup, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamMetricsGroupSuccess(response?.data?.data || {}))
            } else {
                yield put(getMetricsGroupSuccess(response?.data?.data || {}));
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getBDMMetricsData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;
    const isCompare = params.payload?.isCompare;

    try {
        const response = yield call(getBDMMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                if (isCompare) {
                    yield put(getCompareTeamMetricsSuccess(response?.data?.data || {}))
                } else {
                    yield put(getTeamMetricsSuccess(response?.data?.data || {}))
                }
            } else {
                if (isCompare) {
                    yield put(getCompareMetricsSuccess(response?.data?.data || {}))
                } else {
                    yield put(getMetricsSuccess(response?.data?.data || {}));
                }
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getBDMMetricsOverviewData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getBDMMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamMetricsOverviewSuccess(response?.data?.data || {}))
            } else {
                yield put(getMetricsOverviewSuccess(response?.data?.data || {}));
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getBDMRoleBasedMetricsData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getBDMMetrics, actionValue);

        if (response?.success) {
            if (isTeam) {
                yield put(getTeamRoleBasedMetricsSuccess(response?.data?.data || {}))
            } else {
                yield put(getRoleBasedMetricsSuccess(response?.data?.data || {}));
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getBDMMetricsGroupData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getBDMJobsMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamMetricsGroupSuccess(response?.data?.data || {}))
            } else {
                yield put(getMetricsGroupSuccess(response?.data?.data || {}));
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRecruiterMetricsData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;
    const isCompare = params.payload?.isCompare;

    try {
        const response = yield call(getRecruiterMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                if (isCompare) {
                    yield put(getCompareTeamMetricsSuccess(response?.data?.data || {}))
                } else {
                    yield put(getTeamMetricsSuccess(response?.data?.data || {}))
                }
            } else {
                if (isCompare) {
                    yield put(getCompareMetricsSuccess(response?.data?.data || {}))
                } else {
                    yield put(getMetricsSuccess(response?.data?.data || {}));
                }
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRecruiterMetricsOverviewData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getRecruiterMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamMetricsOverviewSuccess(response?.data?.data || {}))
            } else {
                yield put(getMetricsOverviewSuccess(response?.data?.data || {}));
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRecruiterRoleBasedMetricsData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getRecruiterMetrics, actionValue);

        if (response?.success) {
            if (isTeam) {
                yield put(getTeamRoleBasedMetricsSuccess(response?.data?.data || {}))
            } else {
                yield put(getRoleBasedMetricsSuccess(response?.data?.data || {}));
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRecruiterMetricsGroupData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getRecruiterMetricsGroup, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamMetricsGroupSuccess(response?.data?.data || {}))
            } else {
                yield put(getMetricsGroupSuccess(response?.data?.data || {}));
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getAdminMetricsOverviewData({ payload }) {
    const { role } = payload;

    const roleConfig = {
        RA: {
            api: getAdminRAMetricsOverview,
            successAction: getAdminRAMetricsOverviewSuccess
        },
        BDM: {
            api: getAdminBDMMetricsOverview,
            successAction: getAdminBDMMetricsOverviewSuccess
        },
        RECRUITER: {
            api: getAdminRecruiterMetricsOverview,
            successAction: getAdminRecruiterMetricsOverviewSuccess
        }
    };

    try {
        const config = roleConfig[role];
        if (!config) return;

        const response = yield call(config.api, payload);

        if (response?.success) {
            yield put(config.successAction(response?.data?.data || {}));
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    }
}

function* getAdminMetricsGroupData({ payload }) {
    const { role, type } = payload;

    const roleConfig = {
        RA: {
            api: getAdminRAMetricsGroup,
            groupSuccessAction: getAdminRAMetricsGroupSuccess,
            overviewSuccessAction: getAdminRAMetricsOverviewSuccess
        },
        BDM: {
            api: getAdminBDMMetricsGroup,
            groupSuccessAction: getAdminBDMMetricsGroupSuccess,
            overviewSuccessAction: getAdminBDMMetricsOverviewSuccess
        },
        RECRUITER: {
            api: getAdminRecruiterMetricsGroup,
            groupSuccessAction: getAdminRecruiterMetricsGroupSuccess,
            overviewSuccessAction: getAdminRecruiterMetricsOverviewSuccess
        }
    };

    try {
        const config = roleConfig[role];
        if (!config) return;

        const response = yield call(config.api, payload);

        if (response?.success) {
            if (type === "overview") {
                yield put(config.overviewSuccessAction(response?.data?.data || {}));
            } else {
                yield put(config.groupSuccessAction(response?.data?.data || {}));
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getAdminMetricsData(params) {
    const actionValue = params.payload;
    const isCompare = params.payload?.isCompare;

    try {
        const response = yield call(getAdminMetrics, actionValue);
        if (response?.success) {
            if (isCompare) {
                yield put(getAdminCompareMetricsSuccess(response?.data?.data || {}))
            } else {
                yield put(getAdminMetricsSuccess(response?.data?.data || {}))
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {

        yield put(revertStateLoading());
    }
}

function* getUsersData(params) {
    const actionValue = params.payload;

    try {
        const response = yield call(getAllUsers, actionValue);

        if (response?.success) {
            const usersData = response?.data?.data || [];
            const raUsers = usersData?.filter((user) => user?.role?.type === 2);
            const bdmUsers = usersData?.filter((user) => user?.role?.type === 3);
            const recruiterUsers = usersData?.filter((user) => user?.role?.type === 4);

            yield put(setAdminRAUsers(raUsers || []))
            yield put(setAdminBDMUsers(bdmUsers || []))
            yield put(setAdminRecruiterUsers(recruiterUsers || []))
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}
// Total Accounts List API call
function* handleGetAdminTotalAccountsList({ payload }) {
    try {
        const safePayload = { ...payload };
        if (!safePayload.fil || Object.keys(safePayload.fil).length === 0) {
            delete safePayload.fil;
        }

        const response = yield call(getTotalAccountsFromJobsApi, safePayload);
        const apiData = response?.data?.data || [];
        const uniqueMap = {};
        apiData.forEach((item) => {
            const key = item?.companyData?.uiid || item?.companyId;
            if (key && !uniqueMap[key]) {
                uniqueMap[key] = item;
            }
        });

        const uniqueList = Object.values(uniqueMap);
        const formattedList = uniqueList.map((item, index) => ({
            id: index + 1,

            companyName: item?.companyData?.name || "-",
            companyWebsite: item?.companyData?.website || "-",
            companyDomain: item?.companyData?.domain || "-",
            industry: item?.companyData?.industry || "-",

            location: item?.location?.city || "-",
            addedBy: item?.addedByData
                ? `${item.addedByData.firstName || ""} ${item.addedByData.lastName || ""}`.trim()
                : "-",

            addedOn: item?.addedOn
                ? new Date(item.addedOn).toLocaleDateString()
                : "-",
        }));
        const totalUnique = response?.data?.data?.[0]?.totalCount;

        yield put(
            getAdminTotalAccountsListSuccess({
                list: formattedList,
                total: totalUnique,
            })
        );
    } catch (error) {
        console.error("Total Accounts Error:", error);
        yield put(getAdminTotalAccountsListFailure());
    } finally {
        yield put(revertStateLoading());
    }
}
// Backout List API call
function* getBackoutListData(action) {
    try {
        const response = yield call(getAdminBackoutsListApi, action.payload);

        const list = response?.data?.data?.[0]?.data || [];
        const total = response?.data?.data?.[0]?.totalCount || 0;

        yield put(
            getBackoutListSuccess({
                list,
                total,
            })
        );
    } catch (error) {
        console.error("Backout API error", error);
        yield put(getBackoutListFailure());
    }
}

//placements saga
function* getPlacementsListData(action) {
    try {
        const params = action.payload;
        const response = yield call(getPlacementsListApi, {
            ...params,
            coll: "Submission",
            useAggregate: true,
        });
        const apiData =
            response?.data?.data?.[0]?.data ||
            response?.data?.data ||
            [];

        const total =
            response?.data?.data?.[0]?.totalCount ||
            response?.data?.totalCount ||
            0;
        const formattedList = apiData.map((item, index) => {
            const placementStatus = item?.statusHistory
                ?.filter((s) => s.status === 63)
                ?.sort(
                    (a, b) =>
                        new Date(b.addedOn) - new Date(a.addedOn)
                )[0];

            return {
                id: index + 1,

                candidateName:
                    item?.candidateId?.firstName ||
                    item?.candidateId?.name ||
                    "N/A",

                jobTitle:
                    item?.jobPostId?.title || "N/A",

                clientName:
                    item?.companyId?.name || "N/A",

                status: "Placed",

                placedOn: placementStatus?.addedOn
                    ? new Date(
                        placementStatus.addedOn
                    ).toLocaleDateString()
                    : "N/A",
            };
        });

        yield put(
            getPlacementsListSuccess({
                list: formattedList,
                total,
            })
        );
    } catch (error) {
        console.error("Placements Saga Error:", error);
        yield put(getPlacementsListFailure());
    }
}

function* fetchTreeHierarchySaga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(getTreeHierarchyDataSuccess(data));
    } catch (error) {
        yield put(getTreeHierarchyDataFailure(error.message));
    }
}
function* fetchTreeHierarchyNodeTab2Saga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(getTreeHierarchyNodeTab2DataSuccess(data));
    } catch (error) {
        yield put(getTreeHierarchyNodeTab2DataFailure(error.message));
    }
}
function* fetchTreeHierarchyNodeTab3Saga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(getTreeHierarchyNodeTab3DataSuccess(data));
    } catch (error) {
        yield put(getTreeHierarchyNodeTab3DataFailure(error.message));
    }
}
function* getTreeHierarchyNodeTab3TotalCountSaga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const totalCount = response?.data?.data?.[0]?.totalCount || 0;
        yield put(getTreeHierarchyNodeTab3TotalCountSuccess(totalCount));
    } catch (error) {
        yield put(getTreeHierarchyNodeTab3TotalCountFailure(error.message));
    }
}

function* fetchTreeHierarchyNodeSaga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(getTreeHierarchyNodeDataSuccess(data));
    } catch (error) {
        yield put(getTreeHierarchyNodeDataFailure(error.message));
    }
}

function* fetchTreeHierarchyNodeBDMSaga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(getTreeHierarchyNodeBDMSuccess(data));
    } catch (error) {
        yield put(getTreeHierarchyNodeBDMFailure(error.message));
    }
}

function* handleGetBDMTableData(action) {
    try {
        const response = yield call(getBDMTableDataApi, action.payload);
        const responseData = response?.data?.data?.[0] || response?.data?.data || {};
        yield put(getBDMTableDataSuccess(responseData));
    } catch (error) {
        console.error("BDM Table Error:", error);
        yield put(getBDMTableDataFailure());
    }
}

function* fetchTreeHierarchyExtraCountsSaga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(getTreeHierarchyExtraCountsDataSuccess(data));
    } catch (error) {
        yield put(getTreeHierarchyExtraCountsDataFailure(error.message));
    }
}

//recruit tree hirer
function* fetchRecruitTreeHierarchySaga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(getRecruitTreeHierarchyDataSuccess(data));
    } catch (error) {
        yield put(getRecruitTreeHierarchyDataFailure(error.message));
    }
}

function* fetchRecruitTreeHierarchyNodeTab2Saga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(getRecruitTreeHierarchyNodeTab2DataSuccess(data));
    } catch (error) {
        yield put(getRecruitTreeHierarchyNodeTab2DataFailure(error.message));
    }
}

function* fetchRecruitTreeHierarchyNodeTab3Saga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(getRecruitTreeHierarchyNodeTab3DataSuccess(data));
    } catch (error) {
        yield put(getRecruitTreeHierarchyNodeTab3DataFailure(error.message));
    }
}

function* getRecruitTreeHierarchyNodeTab3TotalCountSaga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const totalCount = response?.data?.data?.[0]?.totalCount || 0;
        yield put(getRecruitTreeHierarchyNodeTab3TotalCountSuccess(totalCount));
    } catch (error) {
        yield put(getRecruitTreeHierarchyNodeTab3TotalCountFailure(error.message));
    }
}

function* fetchRecruitTreeHierarchyNodeSaga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(getRecruitTreeHierarchyNodeDataSuccess(data));
    } catch (error) {
        yield put(getRecruitTreeHierarchyNodeDataFailure(error.message));
    }
}

function* fetchRecruitTreeHierarchyNodeBDMSaga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(getRecruitTreeHierarchyNodeBDMSuccess(data));
    } catch (error) {
        yield put(getRecruitTreeHierarchyNodeBDMFailure(error.message));
    }
}

function* fetchgettreeHierarchyMetricWiseDataSaga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(gettreeHierarchyMetricWiseDataSuccess(data));
    } catch (error) {
        yield put(gettreeHierarchyMetricWiseDataFailure(error.message));
    }
}

function* fetchgetrecruitTreeHierarchyMetricWiseDataSaga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(getrecruitTreeHierarchyMetricWiseDataSuccess(data));
    } catch (error) {
        yield put(getrecruitTreeHierarchyMetricWiseDataFailure(error.message));
    }
}

function* fetchgetrecruitTreeHierarchyExtraCountsSaga(action) {
    try {
        const response = yield call(fetchTreeHierarchyApi, action.payload);
        const data = response?.data?.data || [];
        yield put(getTreeHierarchyRecruitExtraCountsDataSuccess(data));
    } catch (error) {
        yield put(getTreeHierarchyRecruitExtraCountsDataFailure(error.message));
    }
}

export function* watchFetchAtsDashboard() {
    yield takeLatest(getRAMetricsStart.type, getRAMetricsData);
    yield takeLatest(getRAMetricsOverviewStart.type, getRAMetricsOverviewData);
    yield takeLatest(getRARoleBasedMetricsStart.type, getRARoleBasedMetricsData);
    yield takeLatest(getRAMetricsGroupStart.type, getRAMetricsGroupData);
    yield takeLatest(getRACompareMetricsStart.type, getRAMetricsData);
    yield takeLatest(getBDMMetricsStart.type, getBDMMetricsData);
    yield takeLatest(getBDMMetricsOverviewStart.type, getBDMMetricsOverviewData);
    yield takeLatest(getBDMRoleBasedMetricsStart.type, getBDMRoleBasedMetricsData);
    yield takeLatest(getBDMMetricsGroupStart.type, getBDMMetricsGroupData);
    yield takeLatest(getBDMCompareMetricsStart.type, getBDMMetricsData);
    yield takeLatest(getRecruiterMetricsStart.type, getRecruiterMetricsData);
    yield takeLatest(getRecruiterMetricsOverviewStart.type, getRecruiterMetricsOverviewData);
    yield takeLatest(getRecruiterRoleBasedMetricsStart.type, getRecruiterRoleBasedMetricsData);
    yield takeLatest(getRecruiterMetricsGroupStart.type, getRecruiterMetricsGroupData);
    yield takeLatest(getRecruiterCompareMetricsStart.type, getRecruiterMetricsData);

    yield takeLatest(getAdminRAMetricsOverviewStart.type, getAdminMetricsGroupData);
    yield takeLatest(getAdminBDMMetricsOverviewStart.type, getAdminMetricsGroupData);
    yield takeLatest(getAdminRecruiterMetricsOverviewStart.type, getAdminMetricsGroupData);
    yield takeLatest(getAdminRAMetricsGroupStart.type, getAdminMetricsGroupData);
    yield takeLatest(getAdminBDMMetricsGroupStart.type, getAdminMetricsGroupData);
    yield takeLatest(getAdminRecruiterMetricsGroupStart.type, getAdminMetricsGroupData);
    yield takeLatest(getAdminMetricsStart.type, getAdminMetricsData);
    yield takeLatest(getAdminCompareMetricsStart.type, getAdminMetricsData);
    yield takeLatest(getAdminUsersStart.type, getUsersData);
    yield takeLatest(getAdminTotalAccountsListStart.type, handleGetAdminTotalAccountsList),
        yield takeLatest(getBackoutListStart.type, getBackoutListData);
    yield takeLatest(getPlacementsListStart.type, getPlacementsListData);
    yield takeLatest(getTreeHierarchyDataStart.type, fetchTreeHierarchySaga);
    yield takeLatest(getTreeHierarchyNodeDataStart.type, fetchTreeHierarchyNodeSaga);
    yield takeLatest(getTreeHierarchyNodeTab2DataStart.type, fetchTreeHierarchyNodeTab2Saga);
    yield takeLatest(getTreeHierarchyNodeTab3DataStart.type, fetchTreeHierarchyNodeTab3Saga);
    yield takeLatest(getTreeHierarchyNodeTab3TotalCountStart.type, getTreeHierarchyNodeTab3TotalCountSaga);
    yield takeLatest(getTreeHierarchyNodeBDMStart.type, fetchTreeHierarchyNodeBDMSaga);
    yield takeLatest(getBDMTableDataStart.type, handleGetBDMTableData);
    yield takeLatest(getRecruitTreeHierarchyDataStart.type, fetchRecruitTreeHierarchySaga);
    yield takeLatest(getRecruitTreeHierarchyNodeDataStart.type, fetchRecruitTreeHierarchyNodeSaga);
    yield takeLatest(getRecruitTreeHierarchyNodeTab2DataStart.type, fetchRecruitTreeHierarchyNodeTab2Saga);
    yield takeLatest(getRecruitTreeHierarchyNodeTab3DataStart.type, fetchRecruitTreeHierarchyNodeTab3Saga);
    yield takeLatest(getRecruitTreeHierarchyNodeTab3TotalCountStart.type, getRecruitTreeHierarchyNodeTab3TotalCountSaga);
    yield takeLatest(getRecruitTreeHierarchyNodeBDMStart.type, fetchRecruitTreeHierarchyNodeBDMSaga);
    yield takeLatest(getTreeHierarchyExtraCountsDataStart.type, fetchTreeHierarchyExtraCountsSaga);
    yield takeLatest(gettreeHierarchyMetricWiseDataStart.type, fetchgettreeHierarchyMetricWiseDataSaga)
    yield takeLatest(getrecruitTreeHierarchyMetricWiseDataStart.type, fetchgetrecruitTreeHierarchyMetricWiseDataSaga)
    yield takeLatest(getTreeHierarchyRecruitExtraCountsDataStart.type, fetchgetrecruitTreeHierarchyExtraCountsSaga)
}